import { IAction } from 'types';
import { call, put, select } from 'typed-redux-saga';
import {
    getOperationData, getMapState, getOmjsChildContainers, getOmjsContainer, getCachedFullContainers
} from 'selectors';
import {
    Service,
    bindActionsTyped,
    onStart,
    every, leading
} from '../service-utils';

import { operation, OperationsService } from '../operations/operations-service';

export interface IMapStateOperationData {
    containerName: string
}

export const defaultMapState: IMapStateOperationData = {
    containerName: null
};

class ListWindowService extends Service {
    static serviceName = 'ListWindowService';
    static generatedStopActionTypes: string[] = [];
    static generatedWatchers: Function[] = [];

    @leading
    @operation('LIST_WINDOW')
    static* showListWindow(action: IAction<string>) {
        const container = yield* select(getOmjsContainer, action.payload, true);

        // let containers = [ container ];
        // if (container.get('type') === 'folder') {
        //     containers = [ ...containers, ...yield* select(getOmjsChildContainers, container.get('id'), true) ];
        // }
        // containers = containers.filter(cont => cont.get('type') !== 'folder' && cont.get('selected'));
        //
        // let objects = [];
        // for (let cont of containers) {
        //     objects = [
        //         ...objects,
        //         ...cont.objects.getArray().map(obj => ({
        //             ...obj['_attributes'],
        //             id: obj['id'],
        //             layerCode: obj.options.layerCode,
        //             area: obj['_attributes'][cont['areaField']]
        //         }))
        //     ];
        // }
        //
        // return {
        //     // container: container['_attributes'],
        //     containerName: container.get('name'),
        //     containers: containers.map(cont => ({ ...cont['_attributes'] })),
        //     objects: objects
        // };
    }
}

export const listWindowService: ListWindowService = new ListWindowService();
export const actions = bindActionsTyped(ListWindowService, listWindowService);
